
<div class="content">
  <div class="col col-2">
    <mat-form-field>
      <input matInput placeholder="weekOfYear" (change)="onChange()" [(ngModel)]="vineyardService.weekOfYear">
    </mat-form-field>
    {{startDate}} - {{endDate}}
  </div>
</div>